import { render, staticRenderFns } from "./InductionQuestions.vue?vue&type=template&id=029ab85c&scoped=true"
import script from "./InductionQuestions.vue?vue&type=script&lang=js"
export * from "./InductionQuestions.vue?vue&type=script&lang=js"
import style0 from "./InductionQuestions.vue?vue&type=style&index=0&id=029ab85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ab85c",
  null
  
)

export default component.exports